import * as system from "styled-system";
import mixed from "./mixed";
var variant = function variant(options) {
  return mixed(system.variant(options));
};
export default variant;